export const RippleKeys = {
    APPROVERS: 'approvers',
    APPROVER_KEYS: {
        alias: 'alias',
        column_index: 'column_index',
        type: 'type'
    },
    last_updated_time_stamp: 'last_updated_time_stamp',
    created_time_stamp: 'created_time_stamp',
    created_by: 'created_by',
    temp_ripple_id: 'temp_ripple_id',
    ripple_mapping_id: 'ripple_mapping_id',
    mapping_id: 'mapping_id',
    id_type: 'id_type',
    ripple_id: 'ripple_id',
    app_id: 'app_id',
    resend_old_parameters: 'resend_old_parameters',
    task: 'task',
    approval_required: 'approval_required',
    is_dynamic_approvers_allowed: 'is_dynamic_approvers_allowed',
    parameters: 'parameters',
    approvers: 'approvers',
    PARAMETER_KEYS: {
        field_id: 'field_id',
        field_type: 'field_type',
        field_values: 'field_values',
        label: 'label',
        source_database: 'source_database'
    }
}

export const RIPPLE_APPROVER_TYPES = {
    APPROVER: "APPROVER",
    APPROVER_LDAP: "APPROVER_LDAP"
}

export const RippleIDTypes = {
    FLEXICO: 'FLEXICO'
}
